import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import styles from './messages.module.scss'
import Link from 'next/link'
import Icon from 'src/@core/components/icon'
import dayjs from 'dayjs'
import { useTranslation } from 'src/utils/i18n'

const RecentCard = pros => {
  // return (
  //   <Card styles={{ marginTop: '20px' }}>
  //     <CardContent>
  //       <div className={styles.cardBox}>
  //         <div className={styles.cardHeader}>
  //           <span className={styles.call}>{t('Recent Messages')}</span>
  //           <Link href={a} className={styles.all}>
  //             {t('All Messages')}
  //           </Link>
  //         </div>
  //         <div className={styles.contentBox}>
  //           <ul>
  //             {data.map(({ guid, frendlyName = '', chatid, messageCount, snippetTimestamp }) => (
  //               <li key={guid}>
  //                 <div className={styles.pic}>{chatid.charAt(0)}</div>
  //                 <div className={styles.main}>
  //                   <span className={styles.name}>
  //                     {frendlyName.substr(0, 15)} ({messageCount})
  //                   </span>
  //                   <span className={styles.phone}>
  //                     <Icon className={styles.icon} icon='mdi:android-messages' />
  //                     {chatid.substr(0, 10)}
  //                   </span>
  //                 </div>
  //                 <div className={styles.month}>{dayjs(snippetTimestamp).format('DD MMMM,YYYY')}</div>
  //               </li>
  //             ))}
  //           </ul>
  //         </div>
  //       </div>
  //     </CardContent>
  //   </Card>
  // )

  return <>123</>
}

export default RecentCard
